import type { ClientMediaItem } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useState, type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';
import { Menu } from 'react-native-paper';

import { ContentCopyIcon } from '@/assets';
import { copyImageToClipboard } from '@/features/chats/utils/message';
import { MediaItemImage } from '@/features/media/components/MediaItemImage';
import { MediaItemSize } from '@/features/media/types/mediaItem';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { ExtendedMenu } from '@/shared/components/ExtendedMenu';

const styles = StyleSheet.create({
  image: {
    backgroundColor: 'transparent',
    width: 200,
    height: 200,
    borderRadius: 8,
    marginTop: 4,
    marginBottom: 12
  }
});

type Props = {
  mediaItem: ClientMediaItem;
  onMediaItemPress: () => void;
};

export const ChatMessageImage: FC<Props> = ({
  mediaItem,
  onMediaItemPress
}) => {
  const { t } = useTranslation(LocalizationNameSpace.CHATS, {
    keyPrefix: 'components.messageMenu'
  });
  const [menuVisible, setMenuVisible] = useState(false);

  return (
    <ExtendedMenu
      visible={menuVisible}
      onDismiss={() => setMenuVisible(false)}
      anchor={
        <MediaItemImage
          style={styles.image}
          mediaItem={mediaItem}
          mediaSize={MediaItemSize.THUMBNAIL}
          onPress={onMediaItemPress}
          onLongPress={() => setMenuVisible(true)}
        />
      }
    >
      <Menu.Item
        leadingIcon={(props) => (
          <ContentCopyIcon
            fill={props.color}
            width={props.size}
            height={props.size}
          />
        )}
        onPress={async () => {
          await copyImageToClipboard(mediaItem);
          setMenuVisible(false);
        }}
        title={t('copy')}
      />
    </ExtendedMenu>
  );
};
